export function Logo({
  size = 24,
  className,
  strokeColor = 'white',
}: {
  size?: number | string;
  className?: string;
  strokeColor?: string;
}) {
  return (
    <svg
      height={size}
      className={className}
      viewBox='0 0 800 800'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='800' height='800' rx='0' fill='currentColor' />
      <path
        d='M379.637 357.043H305.33V308.879H115V249H379.637V357.043Z'
        fill={strokeColor}
      />

      <path
        d='M115 370.06H379.637V479.405L305.33 477.453V429.289H115V370.06Z'
        fill={strokeColor}
      />

      <path d='M379.637 492.422V551H115V492.422H379.637Z' fill={strokeColor} />
      <path
        d='M422.462 356.65H496.46V308.662H686V249H422.462V356.65Z'
        fill={strokeColor}
      />

      <path
        d='M686 369.62H422.462V478.567L496.46 476.622V428.633H686V369.62Z'
        fill={strokeColor}
      />

      <path
        d='M422.462 491.537V549.902H686V491.537H422.462Z'
        fill={strokeColor}
      />
    </svg>
  );
}
